import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { ARTICLES } from "@/data/content";
import { Seo } from "@/components/Seo";

const TAGS = ["All", "Insurance", "Education"];

export default function Knowledge() {
  const [tag, setTag] = useState("All");
  const filtered = tag === "All" ? ARTICLES : ARTICLES.filter((a) => a.tag === tag);

  return (
    <div>
      <Seo
        title="Insurance Knowledge Centre NZ | Quantum Cover"
        description="Plain-English guides on life, health, trauma, income protection and mortgage protection insurance in New Zealand. Learn the basics before you talk to an adviser."
        path="/knowledge"
      />
      <section className="bg-[#0B3D2E] text-white pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 max-w-3xl">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-emerald-400 mb-3">Knowledge Centre</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">Learn at your own pace</h1>
          <p className="mt-5 text-lg text-slate-300">Straightforward guides on insurance and money, written in plain language for New Zealanders.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="flex flex-wrap gap-2 mb-10">
          {TAGS.map((t) => (
            <button
              key={t}
              data-testid={`knowledge-filter-${t.toLowerCase()}`}
              onClick={() => setTag(t)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${tag === t ? "bg-[#0B3D2E] text-white" : "bg-white border border-slate-200 text-slate-600 hover:border-emerald-300"}`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((a) => (
            <Link
              key={a.slug}
              to={`/knowledge/${a.slug}`}
              data-testid={`article-card-${a.slug}`}
              className="group bg-white rounded-3xl border border-slate-200 p-7 shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:-translate-y-1 hover:shadow-[0_16px_50px_rgba(0,0,0,0.08)] transition-[transform,box-shadow] duration-300 flex flex-col"
            >
              <span className="self-start text-xs font-semibold uppercase tracking-wider text-emerald-700 bg-emerald-50 px-3 py-1 rounded-full">{a.tag}</span>
              <h3 className="mt-4 font-display text-xl font-semibold text-[#0B3D2E] leading-snug line-clamp-2 min-h-[3.5rem]">{a.title}</h3>
              <p className="mt-2 text-slate-600 leading-relaxed text-[15px] flex-1 line-clamp-3">{a.excerpt}</p>
              <div className="mt-5 flex items-center justify-between text-sm">
                <span className="flex items-center gap-1.5 text-slate-400"><Clock size={14} /> {a.read}</span>
                <span className="inline-flex items-center gap-1.5 font-medium text-emerald-700 group-hover:gap-2.5 transition-all">Read <ArrowRight size={15} /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
